<template>
  <div class="agent-roles">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col">
                <div class="page-title">Roles</div>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/client/agents/list">Agent</router-link>
                  </li>
                  <li class="breadcrumb-item active">Roles</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <ul class="personal-info">
                        <li>
                          <span class="title">Name:</span>
                          <span class="text">{{ agent.name }}</span>
                        </li>

                        <li>
                          <span class="title">Email:</span>
                          <span class="text">{{ agent.email }}</span>
                        </li>
                      </ul>
                    </div>

                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8">
                      <h6 class="card-title m-b-20">Roles Access</h6>

                      <div class="m-b-30">
                        <template v-if="loading">
                          <div class="w-100">
                            <Skeleton :count="1" />
                          </div>
                        </template>
                        <template v-if="rows.length">
                          <ul
                            v-for="(row, index) in rows"
                            :key="index"
                            class="list-group notification-list"
                          >
                            <li class="list-group-item">
                              {{ row.name }}
                              <div class="status-toggle">
                                <input
                                  :ref="'rel-' + row.id"
                                  type="checkbox"
                                  :id="row.id"
                                  class="check"
                                  @change="handleRolesOne(row.id)"
                                />
                                <label :for="row.id" class="checktoggle"
                                  >checkbox</label
                                >
                              </div>
                            </li>
                          </ul>
                        </template>
                        <template v-else-if="rows.length < 1 && !loading">
                          <div class="w-100">
                            -empty-
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Page Content -->
      </div>
      <!-- Page Wrapper -->
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

export default {
  name: "AgentRoles",
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      loadingAgent: false,
      loading: false,
      rows: [],
      agentId: "",
      agent: {
        name: "",
        email: ""
      }
    };
  },
  created() {
    this.agentId = this.$route.query.id;
    this.loadAgent();
    this.loadItems();
  },
  methods: {
    async handleRolesOne(licenseId) {
      const hasChecked = this.$refs["rel-" + licenseId][0].hasAttribute(
        "checked"
      );
      const serverPayload = {
        agent_id: this.agentId,
        license_id: licenseId
      };
      if (hasChecked) {
        await this.$store
          .dispatch("agent/deleteAgentRolesOneStored", serverPayload)
          .then(response => {
            this.$refs["rel-" + licenseId][0].removeAttribute("checked");
            return;
          })
          .catch(error => {
            console.log(error);
            return;
          });
      } else {
        await this.$store
          .dispatch("agent/updateAgentRolesOneStored", serverPayload)
          .then(response => {
            this.$refs["rel-" + licenseId][0].setAttribute(
              "checked",
              "checked"
            );
            return;
          })
          .catch(error => {
            console.log(error);
            return;
          });
      }
    },
    async loadAgent() {
      this.loadingAgent = await true;
      await this.$store
        .dispatch("agent/getAgentList", { id: this.agentId })
        .then(response => {
          const { data } = response;
          this.agent.name = `${data.data[0].first_name} ${data.data[0].last_name}`;
          this.agent.email = data.data[0].email;
        })
        .catch(error => {
          console.log(error);
        });
      this.loadingAgent = false;
    },
    async loadItems() {
      this.loading = await true;
      const serverParams = {
        name: "",
        description: "",
        page: 0,
        perPage: 100
      };
      await this.$store
        .dispatch("brand/list", serverParams)
        .then(response => {
          const { data } = response;
          this.rows = data.data;
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let serverParamsAgentRel = {
                agent_id: this.agentId,
                license_id: row.id
              };
              this.$store
                .dispatch("agent/getAgentRel", serverParamsAgentRel)
                .then(responseRel => {
                  var resData = responseRel.data;
                  if (resData) {
                    this.$refs["rel-" + row.id][0].setAttribute(
                      "checked",
                      "checked"
                    );
                  }
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/agents/roles.vue